/**
 * conf powinno być interfacem  z klass API wygenerowanych na podstawie swaggera
 * @TODO: powyższe do zrobienia w przyszłości
 */
import { environment } from '../../environments/environment'
import { Configuration } from '../api/configuration';

export function swaggerConf(): Configuration {
    const conf: Configuration = new Configuration();
    conf.withCredentials = true;
    conf.basePath = generateBasePath();
    return conf;
}

export function generateBasePath() {
    const envApiHost = environment.apiHost;
    const externalConfigurationHost = (window as any).external_configuration.host;
    return String(envApiHost ? envApiHost : externalConfigurationHost);
}
